import styled from 'styled-components';
import { select, withQuery } from '@panel/commons/core/themev2';
import { site } from '@panel/commons/helpers';
import trashIcon from '@panel/commons/assets/icons/icon_trash_48x48.svg';
import trashIconHover from '@panel/commons/assets/icons/icon_trash_48x48_hover.svg';
import trashIconHoverVa from '@panel/commons/assets/icons/icon_trash_48x48_hover_VA.svg';
import trashIconHoverUBPE from '@panel/commons/assets/icons/icon_trash_48x48_hover_UBPE.svg';
import { getColor } from '@panel/commons/core/themev3';

const iconTrashHover = () => {
  if (site.id === 'VAMX') return trashIconHoverVa;
  if (site.id === 'UBPE') return trashIconHoverUBPE;
  return trashIconHover;
};

const Subtitle = styled.p`
  color: ${select('darkGray')};
  font-size: 1.4rem;
  margin-top: -20px;
`;

const SectionContainer = styled.div`
  margin-top: 24px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
`;

const ButtonsContainer = styled.div`
  ${withQuery.xs.down()} {
    width: 100%;
    display: flex;
    flex-flow: wrap;
  }
`;

const InputVideo = styled.input`
  width: 370px;
  height: 48px;
  border-radius: 8px;
  border: 1px solid ${select('midDarkGray')};
  text-indent: 10px;
  margin-right: 16px;
  :focus {
    border: 1px solid ${getColor('primary')};
    outline: none;
  }
  ${withQuery.xs.down()} {
    width: 314px;
    margin-right: 0px;
    margin-bottom: 24px;
  }
`;

const ErrorMessage = styled.span`
  color: ${props => (props.notRed ? select('black') : select('red105'))};
  display: inherit;
  padding: 7px 0px 0px 15px;
  font-size: 12px;
`;

const ErrorMessageLg = styled.span`
  color: ${props => (props.notRed ? select('black') : select('red105'))};
  display: inherit;
  padding: 7px 0px 0px 15px;
  font-size: 12px;
  ${withQuery.xs.down()} {
    display: none;
  }
`;

const ErrorMessageMobile = styled.span`
  color: ${props => (props.notRed ? select('black') : select('red105'))};
  display: none;
  padding: 7px 0px 0px 15px;
  ${withQuery.xs.down()} {
    display: inherit;
  }
`;

const AddButton = styled.button`
  width: 105px;
  height: 48px;
  border-radius: 8px;
  border: 1px solid ${getColor('primary')};
  cursor: pointer;
  ${withQuery.xs.down()} {
    width: 314px;
  }
  :disabled {
    background: ${select('lightGray')};
    border: 1px solid ${select('lightGray')};
  }
`;

const VideoList = styled.div`
  max-height: calc(430px * ${props => (props.showing ? props.videos : 2)});
  transition: max-height 1s ease;
  overflow: hidden;
  ${withQuery.xs.down()} {
    max-height: calc(310px * ${props => (props.showing ? props.videos : 2)});
  }
`;

const Video = styled.div`
  margin-top: 48px;
  iframe {
    width: 560px;
    height: 316px;
    border-radius: 8px 8px 0px 0px;
  }
  ${withQuery.xs.down()} {
    iframe {
      width: 314px;
      height: 198px;
    }
  }
`;
const VideoDetail = styled.div`
  height: 64px;
  width: 560px;
  background: #ffffff;
  border: 0.5px solid ${select('midDarkGray')};
  border-radius: 0px 0px 8px 8px;
  margin-top: -8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  span:first-child {
    width: 485px;
    white-space: break-spaces;
  }
  ${withQuery.xs.down()} {
    width: 314px;
    span:first-child {
      width: 215px;
    }
  }
`;
const TrashIcon = styled.span`
  width: 48px;
  height: 48px;
  background-image: url(${trashIcon});
  cursor: pointer;
  &:hover {
    background-image: url(${iconTrashHover});
  }
`;

const ToggleVideo = styled.button`
  margin-top: 24px;
  cursor: pointer;
  display: flex;
  span {
    height: 18px;
    font-family: Hind;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.3;
    color: #000000;
  }
  svg {
    margin-left: 8px;
  }
`;

const ContainerCheck = styled.div`
  display: flex;
  margin-top: 24px;
  input {
    margin-right: 8px;
  }
`;

const LabelCheckPortada = styled.label``;

export {
  Subtitle,
  SectionContainer,
  ButtonsContainer,
  InputVideo,
  ErrorMessage,
  AddButton,
  VideoList,
  Video,
  VideoDetail,
  TrashIcon,
  ToggleVideo,
  ContainerCheck,
  LabelCheckPortada,
  ErrorMessageLg,
  ErrorMessageMobile
};
